import { useEffect, useState } from 'react'
import useProductCollection from 'modules/react/loan-calculator/hooks/useProductCollection'

const getUsedCarProductId = (productCollection) => {
  const targetProducts = ['Privat/Brugt', 'Brugt']

  for (const product of productCollection.products) {
    if (targetProducts.includes(product.name)) {
      return product.productId
    }
  }

  return null
}

const useProductId = (apiUrl, companyId, accessToken) => {
  const [productId, setProductId] = useState(null)
  const {
    productCollection,
    productCollectionIsLoading,
    productCollectionError
  } = useProductCollection(apiUrl, companyId, accessToken)

  useEffect(() => {
    if (productCollection) {
      setProductId(getUsedCarProductId(productCollection))
    }
  }, [productCollection])

  return productId
}

export default useProductId
